<ng-container *ngIf="isOtpService==false">
<app-not-refresh-appbar >OTP {{formPage}}</app-not-refresh-appbar>

<div id="appCapsule">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <h5 class="text-white">{{ 'otpdescription' | translate}}</h5>
                    <h4 class="text-white font-weight-bold"> {{phoneNumber}}</h4>
                    <h5 class="text-white">{{ 'otptitle' | translate}}</h5>                    
                </div>
                <div class="col-12">
                    <code-input [isCodeHidden]="false" [codeLength]="6" (codeChanged)="onCodeCompleted($event)"
                    (keyup.enter)="validateOtp()" class="text-white"></code-input>
                    <p id="passErr" class="text-warning text-center mt-3"></p>
                    <div class="counterTimer" *ngIf="counterTimer >0">{{counterTimer}}</div>
                    <a class="btn btn-text-primary float-right" (click)="actionType == 'NEWDIVICE'?getNewOtp():getOtp()"
                        *ngIf="counterTimer == 0">Resend OTP</a>
                </div>
            </div>           
            <div class="row justify-content-center">
                    <button type="button" class="btn btn-primary"
                        (click)="actionType == 'NEWDIVICE'? getNewDeviceOtp(): checkOtp()">{{ 'next' | translate}}</button>
            </div>
            <div class="row mt-4">
                <div class="col-12">
                    <h5 class="text-white font-weight-bold text-center" (click)="goToServicePhone()">
                        {{'code_err_msg' | translate}} {{'help' | translate}}
                    </h5>
                </div>    
            </div>
        </div>
</div>
</ng-container>

<ng-container *ngIf="isOtpService==true">
    <app-otp-service-phone (backemit)="showOptPage($event)"></app-otp-service-phone>
</ng-container>


<!-- * App Capsule -->
<!-- 
    <ngx-spinner bdColor = "rgb(6,56,107)" size = "large" color = "#fff" type = "ball-spin-clockwise" [fullScreen] = "true"></ngx-spinner> -->